import React from "react";
import { Row } from "react-bootstrap";
import { ProjectVariable } from "../../pages/Admin/ProfessionalServices/common/types/ProjectVariable";
import UserDefinedField from "../UserDefinedField/UserDefinedField";

interface UserDefinedFieldCollectionProps {
  userDefinedFields?: ProjectVariable[];
  sectionTitle?: string;
  sectionStyle?: object;
  fieldStyle?: object;
  disabled?: boolean;
  onChange?: (ProjectVariable) => void;
}

const UserDefinedFieldCollection: React.FC<UserDefinedFieldCollectionProps> = ({
  userDefinedFields,
  sectionTitle,
  sectionStyle,
  fieldStyle,
  disabled,
  onChange,
}) => {
  if ((userDefinedFields?.length || 0) > 0) {
    return (
      <div>
        {sectionTitle && (
          <div className="text16Bold">{`${sectionTitle}`}</div>
        )}
        <Row style={ sectionStyle ? sectionStyle : {}}>
          {userDefinedFields?.map((fieldDefinition) => {
            return (
              <UserDefinedField
                fieldDefinition={fieldDefinition}
                disabled={disabled}
                onChange={onChange}
                style={fieldStyle}
              />
            )
          })}
        </Row>
      </div>
    )
  }
}

export default UserDefinedFieldCollection;
